import React, { Suspense, useEffect } from 'react';
import axios from 'axios';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import LoginRoutesPage from './login/IndexPage';
import HomeIndexPage from './home/IndexPage';

const routes = [
  {
    path: '/portal',
    component: HomeIndexPage
  },
  {
    path: '/login',
    component: LoginRoutesPage
  },
  {
    path: '/privileged/login',
    component: React.lazy(() => import('./privileged/login/login-form')),
    exact: true
  },
  {
    path: '/privileged/login/mfa-bind',
    component: React.lazy(() => import('./privileged/login/mfa-bound')),
    exact: true
  },
  {
    path: '/privileged/login/mfa-verify',
    component: React.lazy(() => import('./privileged/login/mfa-verfify')),
    exact: true
  },
  {
    path: '/privileged/login/mfa-success',
    component: React.lazy(() => import('./privileged/login/mfa-bound-success')),
    exact: true
  },
  {
    path: '/privileged/logout',
    component: React.lazy(() => import('./privileged/logout/IndexPage'))
  },
  {
    path: '/privileged/console',
    component: React.lazy(() => import('./privileged/console/IndexPage'))
  },
  {
    path: '/privilege-checkin',
    component: React.lazy(() => import('./privilege-checkin/IndexPage'))
  },
  {
    path: '/verify',
    component: React.lazy(() => import('./gas/verify/IndexPage')),
    exact: true
  },
  {
    path: '/documents',
    component: React.lazy(() => import('./document/IndexPage'))
  },
  {
    path: '/sso/logout',
    component: React.lazy(() => import('./gas/logout/IndexPage')),
    exact: true
  },
  {
    path: '/redirect',
    component: React.lazy(() => import('./gas/transition/IndexPage'))
  },
  {
    path: '/service',
    component: React.lazy(() => import('./service/IndexPage'))
  },
  {
    path: '/aws',
    component: React.lazy(() => import('./aws/IndexPage'))
  },
  {
    path: '/user',
    component: React.lazy(() => import('./user/IndexPage'))
  },
  {
    path: '/console',
    component: React.lazy(() => import('./console/IndexPage'))
  },
  {
    path: '/details/user',
    component: React.lazy(() => import('./details/user/IndexPage'))
  },
  {
    path: '/details/group',
    component: React.lazy(() => import('./details/group/IndexPage'))
  },
  {
    path: '/details/policy',
    component: React.lazy(() => import('./details/policy/IndexPage'))
  },
  {
    path: '/products/:name/index-page',
    component: React.lazy(() => import('./products/IndexPage'))
  },
  {
    path: '/prismacloud',
    component: React.lazy(() => import('./prismacloud/IndexPage'))
  },
  {
    path: '/products/:name/staging-index-page',
    component: React.lazy(() => import('./products/IndexPage'))
  }
];

const App = () => {
  const history = useHistory();

  useEffect(() => {
    history.listen(() => {
      axios.defaultSource.cancel('cancel request');
      axios.defaultSource = axios.CancelToken.source();
    });
  }, [history]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        {routes.map(route => (
          <Route {...route} />
        ))}
        <Redirect from='/' to='/portal' />
      </Switch>
    </Suspense>
  );
};

export default App;
